export const cyberVariant = {
  list: {
    backgroundColor: 'blue.700',
    color: 'neutral.700',
  },
  trigger: {
    borderBottom: '3px solid',
    borderColor: 'blue.600',
    backgroundColor: 'blue.700',
    color: 'neutral.white',
    _selected: {
      backgroundColor: 'blue.600',
    },
    _hover: {
      backgroundColor: 'blue.500',
      borderColor: 'skyBlue',
      _selected: {
        backgroundColor: 'blue.600',
        borderColor: 'blue.500',
      },
    },
    _disabled: {
      backgroundColor: 'neutral.850',
      borderColor: 'blue.700',
      color: 'neutral.600',
      _hover: {
        backgroundColor: 'neutral.850',
        borderColor: 'blue.700',
      },
    },
  },
  contentGroup: {
    background: 'neutral.700',
  },
  content: {
    background: 'neutral.700',
  },
};
